import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  mainWrapper: {
    maxWidth: 376,
    minHeight: 346,

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: SPACES.m,
  },
  requestFormWrapper: {
    minHeight: 160,

    gap: SPACES.m,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  keyCardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.m,
  },
  keyTextWrapper: {
    '&&': {
      backgroundColor: theme.palette.custom.grey,
      padding: SPACES.s,
    },
  },
  keyText: {
    '&&': {
      wordBreak: 'break-all',

      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.medium,
      color: theme.palette.custom.warning,
    },
  },
  helpIconWrapper: {
    '&&': {
      marginLeft: SPACES.xs,

      display: 'flext',
      alignItems: 'center',
    },
  },
  helpIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      width: 16,
      height: 16,
    },
  },
  connectionHelpText: {
    '&&': {
      marginBottom: SPACES.xs,

      fontSize: FONTS.SIZES.xs,
      color: theme.palette.custom.darkBlue2,
    },
  },
  connectionButtonWrapper: {
    [theme.breakpoints.up('tablet')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
}))
